/**
 * Legacy SIME schema dual-column trap.
 *
 * The `usuario` table from MySQL DigitalOcean (3sod) has TWO columns for naming:
 *   - `nombre`  : historical full-name string ("Cristobal Farfan Pavez")
 *   - `nombres` : first-name-only field ("Cristobal"), added later
 *
 * Concatenating `nombre + apaterno + amaterno` duplicates apellidos in ~90%
 * of legacy rows (123/137 as of 2026-05-22). The correct display is
 *   `(nombres ?? nombre) + apaterno + amaterno`
 *
 * Use this helper anywhere a "FirstName LastA LastB" string is needed.
 * Do NOT manually `${u.nombre} ${u.apaterno} ${u.amaterno}` — that is the
 * recurring bug pattern (see worker-assignment-panel.tsx:172 postmortem).
 */
export interface NameParts {
  nombre: string;
  nombres?: string | null;
  apaterno?: string | null;
  amaterno?: string | null;
}

export function formatFullName(u: NameParts): string {
  const first = (u.nombres ?? u.nombre).trim();
  return [first, u.apaterno, u.amaterno].filter(Boolean).join(' ');
}
